import React from 'react';
import Layout from '../components/layout/Layout';
import { companyInfo } from '../data/mock';

const PrivacyPage = () => {
  return (
    <Layout>
      <section className="bg-white py-16">
        <div className="container-main">
          <h1 className="text-4xl md:text-5xl font-bold text-navy font-display mb-8">Privacy Policy</h1>
          
          <div className="max-w-3xl prose prose-lg text-gray-600">
            <p className="text-sm text-gray-500 mb-8">Last updated: August 2025</p>
            
            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">1. Information We Collect</h2>
            <p className="mb-4 leading-relaxed">
              {companyInfo.name} collects information you provide directly to us, including name, email address, phone number, company name, and project details when you contact us or use our services.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="mb-4 leading-relaxed">
              We use the information we collect to:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Provide, maintain, and improve our services</li>
              <li>Communicate with you about projects and updates</li>
              <li>Send you technical notices and support messages</li>
              <li>Respond to your comments and questions</li>
              <li>Protect against fraudulent or illegal activity</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">3. Information Sharing</h2>
            <p className="mb-4 leading-relaxed">
              We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as required by law or to protect our rights.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">4. Data Security</h2>
            <p className="mb-4 leading-relaxed">
              We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">5. Data Retention</h2>
            <p className="mb-4 leading-relaxed">
              We retain your personal information for as long as necessary to provide our services and fulfill the purposes outlined in this policy, unless a longer retention period is required by law.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">6. Your Rights</h2>
            <p className="mb-4 leading-relaxed">
              You have the right to access, correct, or delete your personal information. You may also request a copy of your data or ask us to restrict processing of your information.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">7. Contact Us</h2>
            <p className="mb-4 leading-relaxed">
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <p className="mb-2">{companyInfo.name}</p>
            <p className="mb-2">{companyInfo.address}</p>
            <p className="mb-2">Email: {companyInfo.email}</p>
            <p className="mb-2">Phone: {companyInfo.phone}</p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPage;
